export class Login {
    UserName: any;
    UserPassword : any;
}
